import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeactivateGuardService implements CanDeactivate<IDeactivateComponent> {
  component: Object;
    route: ActivatedRouteSnapshot;

    constructor() {
    }

    canDeactivate(component: IDeactivateComponent,
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
        nextState: RouterStateSnapshot): Observable<any> | Promise<boolean> | boolean {
        return   component.canExit?component.canExit():true;
    }
}

export interface IDeactivateComponent {
    canExit: () => Observable<any> | Promise<boolean> | boolean;
}